<div class="row center">
    <div class="qrcode-container">
        <!-- NOTE: If you change the width here, also change the width in the scss file -->
        <qrcode *ngIf="user" [qrdata]="user.userId" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
</div>
